export default {
  FormLabel: {
    baseStyle: {
      fontSize: 'sm',
      fontWeight: 'semibold',
    },
    sizes: {},
    variants: {},
  },
};
